var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6002 89.0766V94.0514L115.086 125.474C118.421 128.087 121.548 128.087 124.469 125.474C127.39 122.862 127.39 119.734 124.469 116.092L93.046 84.6056H88.0712",
    fill: "#0046FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6002 89.0766V94.0514L115.086 125.474C118.421 128.087 121.548 128.087 124.469 125.474C127.39 122.862 127.39 119.734 124.469 116.092L93.046 84.6056H88.0712",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4059 85.0032C94.5771 77.8244 98.2925 68.5045 98.2925 58.366C98.2925 35.759 79.9676 17.4341 57.3606 17.4341C34.7536 17.4341 16.4287 35.759 16.4287 58.366C16.4287 80.973 34.7536 99.2979 57.3606 99.2979C67.4991 99.2979 76.819 95.5825 83.9978 89.4112",
    fill: "#0046FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4059 85.0032C94.5771 77.8244 98.2925 68.5045 98.2925 58.366C98.2925 35.759 79.9676 17.4341 57.3606 17.4341C34.7536 17.4341 16.4287 35.759 16.4287 58.366C16.4287 80.973 34.7536 99.2979 57.3606 99.2979C67.4991 99.2979 76.819 95.5825 83.9978 89.4112",
    fill: "white",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3606 86.7034C41.6806 86.7034 29.0232 74.046 29.0232 58.366C29.0232 42.6859 41.6806 30.0285 57.3606 30.0285C73.0407 30.0285 85.6981 42.6859 85.6981 58.366C85.6981 74.046 73.0407 86.7034 57.3606 86.7034Z",
    fill: "#0046FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3606 86.7034C41.6806 86.7034 29.0232 74.046 29.0232 58.366C29.0232 42.6859 41.6806 30.0285 57.3606 30.0285C73.0407 30.0285 85.6981 42.6859 85.6981 58.366C85.6981 74.046 73.0407 86.7034 57.3606 86.7034Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8679 69.8632C66.6466 71.0846 64.6737 71.0846 63.4523 69.8632L56.782 63.1929L50.1429 69.8319C48.9216 71.0532 46.9487 71.0532 45.7273 69.8319C44.506 68.6106 44.506 66.6377 45.7273 65.4163L52.3664 58.7773L45.696 52.1383C44.4747 50.9169 44.4747 48.944 45.696 47.7227C46.9174 46.5013 48.8903 46.5013 50.1116 47.7227L56.782 54.3617L63.421 47.7227C64.6423 46.5013 66.6153 46.5013 67.8366 47.7227C69.0579 48.944 69.0579 50.9169 67.8366 52.1383L61.1976 58.7773L67.8366 65.4163C69.0892 66.6377 69.0892 68.6419 67.8679 69.8632Z",
    fill: "#FF5C35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8679 69.8632C66.6466 71.0846 64.6737 71.0846 63.4523 69.8632L56.782 63.1929L50.1429 69.8319C48.9216 71.0532 46.9487 71.0532 45.7273 69.8319C44.506 68.6106 44.506 66.6377 45.7273 65.4163L52.3664 58.7773L45.696 52.1383C44.4747 50.9169 44.4747 48.944 45.696 47.7227C46.9174 46.5013 48.8903 46.5013 50.1116 47.7227L56.782 54.3617L63.421 47.7227C64.6423 46.5013 66.6153 46.5013 67.8366 47.7227C69.0579 48.944 69.0579 50.9169 67.8366 52.1383L61.1976 58.7773L67.8366 65.4163C69.0892 66.6377 69.0892 68.6419 67.8679 69.8632Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNo);
export default __webpack_public_path__ + "static/media/Search_No.8f693bff15981bd2507109d4031bcd19.svg";
export { ForwardRef as ReactComponent };